import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_COST_TRACKER_API_URL,
});

export const fetchCostOverview = async ({ startDate, endDate }) => {
  const res = await client.get('/api/dashboard/overview', {
    params: { startDate, endDate },
  });
  return res.data;
};

export const fetchCostUser = async (phone, { startDate, endDate }) => {
  const res = await client.get(
    `/api/dashboard/user/${encodeURIComponent(phone)}`,
    { params: { startDate, endDate } },
  );
  return res.data;
};

export const fetchCostAnalytics = async ({ startDate, endDate }) => {
  const res = await client.get('/api/dashboard/analytics', {
    params: { startDate, endDate },
  });
  return res.data;
};
